import React, { createContext, ReactNode, useContext, useState } from "react";

interface DropdownContextType<T> {
  value?: T;
  setValue: (value?: T) => void;
}

const createDropdownContext = <T,>() => {
  const context = createContext<DropdownContextType<T> | undefined>(undefined);

  const useDropdownContext = () => {
    const ctx = useContext(context);
    if (!ctx) {
      throw new Error(
        "useGenericContext must be used within a DropdownProvider",
      );
    }
    return ctx;
  };

  const DropdownProvider: React.FC<{ children: ReactNode }> = ({
    children,
  }) => {
    const [value, setValue] = useState<T>();
    return (
      <context.Provider value={{ value, setValue }}>
        {children}
      </context.Provider>
    );
  };

  return { useDropdownContext, DropdownProvider };
};

export default createDropdownContext;
